// extracted by mini-css-extract-plugin
module.exports = {"separator":"TabsListView_separator__191bJ","listDataArea":"TabsListView_listDataArea__3O3ew","footer":"TabsListView_footer__3EcIe","center":"TabsListView_center__1T3dQ"};